define(function(require, exports, module) {
    'use strict';

    var serverUtil = require('util/server.util');
    var VirtualCardReplacer = require('replacers/virtual-card/orenes-theme/core.virtual-card.view');

    module.exports = VirtualCardReplacer.extend({
        render: function() {
            if (this.name === 'VIRTUAL_CARD' || this.name === 'virtualcard') {
                this.renderQRCode();
            } else {
                this.renderAppleWallet();
            }

            return this;
        },

        renderQRCode: function() {
            serverUtil.getURLsRequest({
                urlTypeList: ['QR']
            })
            .done(function(response) {
                if (response.data && response.data.urlList.length) {
                    this.el.innerHTML = this.tmpl('qr-code', {
                        qr_code_src: response.data.urlList[0].url
                    });
                }
            }.bind(this))
            .fail(function() {
                this.el.innerHTML = this.tmpl('qr-code', {
                    error: true
                });
            }.bind(this));
        }
    });
});
